import Vue from 'vue'

export default {
  endpoint: 'admin/emptycache',
  async emptyCache () {
    return Vue.http.get(this.endpoint)
  }
}



// WEBPACK FOOTER //
// ./src/application/cacheManagement.js